const project = {
	name: 'fe-simuladorpublicopyme',
	version: '3.7.0',
};

const apiUrl = 'https://apilocal.bci.cl/bci-produccion/api-bci';
const publicWebOrigin = 'https://financiamientopyme.bci.cl';

export const SITE_RECAPTCHA_KEY = '6Ld86MUUAAAAABys_wPL-N-vjt-ADus5D4CD4dYO';

export const fe_products = {
	simuladorFogape: 'https://swc.bci.cl/pyme/fe-simuladorpublicofogape-pyme-re-v1-3',
	simuladorCompraCartera: 'https://swc.bci.cl/pyme/fe-simuladorpublicocompracartera-pyme-re-v1-1',
	simuladorFactoring: '',
};

export const environment = {
	production: true,
	header: {
		'X-IBM-Client-Id': 'd47111e8-dc9a-4dbc-83af-9f8274c9f90a',
		'Application-Id': `${project.name}-${project.version}`,
		'Reference-Service': project.name,
		'Content-Type': 'application/json',
		'Origin-addr': '104.17.67.9',
		Channel: '132',
	},
	endPoints: {
		simuladorPublicoPymeExp: `${apiUrl}/operaciones-y-ejecucion/creditos-y-depositos/ms-simuladorpublicopyme-exp/v2.1`,
	},
	simulatorBaseUrl: `${publicWebOrigin}/nuevaWeb`,
	vambe: {
		baseUrl: 'https://api.vambe.ai/api/redirect/website/to-whatsapp',
		clientId: '73122fd6-f03b-4de6-b854-b3891d6824e9',
		phoneNumber: '56986275049',
	},
};
